module.exports = __webpack_public_path__ + "static/media/warning.8fc922ce.svg";